"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokenDataExtractor = void 0;
var tslib_1 = require("tslib");
var __1 = require("..");
var AccessMethodType;
(function (AccessMethodType) {
    AccessMethodType["SOCIAL"] = "social";
})(AccessMethodType || (AccessMethodType = {}));
var ProviderCode;
(function (ProviderCode) {
    ProviderCode["APE"] = "ape";
})(ProviderCode || (ProviderCode = {}));
var decodePayload = function (token) {
    if (!token) {
        return null;
    }
    try {
        var payloadPart = token.split(".")[1];
        if (!payloadPart) {
            return null;
        }
        var decodedPayload = atob(payloadPart);
        return JSON.parse(decodedPayload);
    }
    catch (error) {
        return null;
    }
};
var extractRefreshTokenDeviceId = function (refreshToken) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var tokenDecodedPayload;
    var _a;
    return tslib_1.__generator(this, function (_b) {
        tokenDecodedPayload = decodePayload(refreshToken);
        if (tokenDecodedPayload) {
            return [2 /*return*/, (_a = tokenDecodedPayload === null || tokenDecodedPayload === void 0 ? void 0 : tokenDecodedPayload.deviceId) !== null && _a !== void 0 ? _a : null];
        }
        return [2 /*return*/, null];
    });
}); };
var extractEmailAccountId = function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var accessToken, decodedPayload, emailAccountAccessMethod;
    var _a, _b;
    return tslib_1.__generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, __1.authSuiteDataLocalStorageService.getApplicationAccessToken()];
            case 1:
                accessToken = _c.sent();
                decodedPayload = decodePayload(accessToken);
                if (decodedPayload) {
                    emailAccountAccessMethod = (_a = decodedPayload === null || decodedPayload === void 0 ? void 0 : decodedPayload.accessMethods) === null || _a === void 0 ? void 0 : _a.find(function (accessMethod) { return accessMethod.type === AccessMethodType.SOCIAL && accessMethod.providerCode === ProviderCode.APE; });
                    return [2 /*return*/, (_b = emailAccountAccessMethod === null || emailAccountAccessMethod === void 0 ? void 0 : emailAccountAccessMethod.providerUserCode) !== null && _b !== void 0 ? _b : null];
                }
                return [2 /*return*/, null];
        }
    });
}); };
var extractAccountId = function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var accessToken, decodedPayload;
    var _a, _b;
    return tslib_1.__generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, __1.authSuiteDataLocalStorageService.getApplicationAccessToken()];
            case 1:
                accessToken = _c.sent();
                decodedPayload = decodePayload(accessToken);
                if (decodedPayload) {
                    return [2 /*return*/, (_b = (_a = decodedPayload === null || decodedPayload === void 0 ? void 0 : decodedPayload.account) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null];
                }
                return [2 /*return*/, null];
        }
    });
}); };
exports.tokenDataExtractor = {
    extractEmailAccountId: extractEmailAccountId,
    extractAccountId: extractAccountId,
    extractRefreshTokenDeviceId: extractRefreshTokenDeviceId,
};
